// 수동 채점(말하기·쓰기) 점수 범위 — 채점 대시보드(GradingDashboard)의 「채점하기/채점 수정」 점수 칸.
// 점수는 0 ~ 문항 배점이다. <input type="number"> 의 min/max 는 화살표만 막고 직접 친 값(333, -5, 1e5)은 막지 않으며,
// 성취도 백엔드 PUT /exam-answers/answerUpdate(OpenAPI AnswerScoreUpdate)에도 범위 제약이 없어 화면 규칙으로 맞춘다(docs/시험_답안_API.md 12절).
// 강사 화면과 같은 로직이다(2026-10-23 강사 화면팀 통지에 맞춤).

// 수동 채점 점수 상한 — 문항 배점(학생이 푼 버전의 스냅샷 score). 없으면 10
export const manualScoreMax = (question) => {
  const max = Number(question && question.score)
  return max > 0 ? max : 10
}

// 0 ~ 상한으로 맞춘다. 숫자가 아닌 값(빈 칸 등)은 null
export const clampManualScore = (value, max) => {
  if (value === '' || value === null || value === undefined) return null
  const score = Number(value)
  if (Number.isNaN(score)) return null
  return Math.min(Math.max(score, 0), max)
}
